@if(initializing) {
    <div class="spinner-container d-flex justify-content-center align-items-center">
        <mat-spinner></mat-spinner>
    </div>
} @else {
    <div class="container-fluid mb-5 px-3">
        <div class="mt-3 d-flex justify-content-between">
            <div class="font-weight-bold">
                <h1>Equifax Results Lookup</h1>
            </div>
        </div>
        <mat-card class="mt-3 pb-5" *ngIf="!initializing">
            <div id="legend-container">
                <div class="d-flex align-items-center">
                    <h2 id="legend-header" class="text-muted">{{ userContextProvider.isNaUser() ? 'Screening' : 'Verification d' }} Result Legend</h2>
                    <!-- <div id="legend-btn" (click)="toggleLegendVisibility()">{{ getLegendVisibilityToggleText() }}</div> -->
                </div>
                <div class="d-flex flex-row mt-2" [style.display]="legendVisible ? 'flex': 'none !important'">
                    <div class="d-flex flex-row align-items-center">
                        <mat-chip class="legend-table-chip green"></mat-chip>
                        <div class="mx-2 legend-chip-name">Success</div>
                    </div>
                    <div class="d-flex flex-row align-items-center legend-element">
                        <mat-chip class="legend-table-chip dark-blue"></mat-chip>
                        <div class="mx-2 legend-chip-name">Consider</div>
                    </div>
                    <div class="d-flex flex-row align-items-center legend-element">
                        <mat-chip class="legend-table-chip light-blue"></mat-chip>
                        <div class="mx-2 legend-chip-name">Processing</div>
                    </div>
                    <div class="d-flex flex-row align-items-center legend-element">
                        <mat-chip class="legend-table-chip grey"></mat-chip>
                        <div class="mx-2 legend-chip-name">No {{ userContextProvider.isNaUser() ? 'Screening' : 'Verification' }}</div>
                    </div>
                </div>
            </div>
            <div class="row pt-3 align-items-center">
                <div class="col-lg-9 col-12 d-flex flex-column" id="filters-container">
                    <div class="d-flex flex-row align-items-center">
                        <mat-icon *ngIf="filterDefinitions && filterDefinitions.length > 0" class="filter-icon">filter_list</mat-icon>
                        <app-data-table-filter class="filter" *ngFor="let filterDefinition of filterDefinitions" [filterDefinition]="filterDefinition" [disable]="displayLoadingIndicator">
                            <ng-template #filters></ng-template>
                        </app-data-table-filter>
                    </div>
                </div>
                <div class="col-lg-3 col-12">
                    <form>
                        <mat-form-field appearance="outline" class="search-bar">
                            <mat-label class="search-bar-label">
                                <mat-icon class="search-icon">search</mat-icon>
                                <span>Search</span>
                            </mat-label>
                            <input matInput (keyup.enter)="onSearchEvent(searchKeyword.value)" (keyup.backspace)="onDeleteKeyUp(searchKeyword.value)" #searchKeyword>
                            <button type="button" *ngIf="searchKeyword.value" matSuffix mat-icon-button aria-label="Clear"
                                (click)="clearSearch(searchKeyword)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </form>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12">
                    <div class="d-flex flex-row align-items-center pt-2" id="filter-pills-container">
                        <app-data-table-filter-pill *ngFor="let filterPill of filterPills | keyvalue" [filterState]="filterPill.value" (closeClickEvent)="onFilterPillCloseEvent($event)" [disable]="displayLoadingIndicator"></app-data-table-filter-pill>
                    </div>
                    <table matSort mat-table [dataSource]="dataSource" class="mb-3" (matSortChange)="onSortEvent($event)" matSortDisableClear>
                        <ng-container matColumnDef="reservationId">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef> Safely Res. ID </th>
                            <td mat-cell *matCellDef="let element"> {{element.reservationId}} </td>
                        </ng-container>
                        <ng-container matColumnDef="reservationReferenceId">
                            <th mat-header-cell *matHeaderCellDef> Reservation ID </th>
                            <td mat-cell *matCellDef="let element"> {{element.reservationReferenceId}} </td>
                        </ng-container>
                        <ng-container matColumnDef="fullName">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef> Guest Name </th>
                            <td mat-cell *matCellDef="let element"> {{element.fullName}} </td>
                        </ng-container>
                        <ng-container matColumnDef="verifiedDate">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef> Date {{ userContextProvider.isNaUser() ? 'Screened' : 'Verified'}} </th>
                            <td mat-cell *matCellDef="let element"> {{element.verifiedDate}} </td>
                        </ng-container>
                        <ng-container matColumnDef="verificationResultCode">
                            <th mat-header-cell *matHeaderCellDef class="table-chip-header"> {{ userContextProvider.isNaUser() ? 'Screening' : 'Verification' }}  Result </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-chip-set class="mat-chip-list-stacked">
                                    <mat-chip [ngClass]="element.verificationResultCode?.color" class="table-chip">
                                        {{element.verificationResultCode?.text}}
                                    </mat-chip>
                                </mat-chip-set>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="identityResultCode">
                            <th mat-header-cell *matHeaderCellDef class="table-chip-header" [matTooltip]="'Identity'"> I </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-chip-set class="mat-chip-list-stacked">
                                    <mat-chip [ngClass]="element.identityResultCode?.color" class="table-chip">
                                        {{element.identityResultCode?.text}}
                                    </mat-chip>
                                </mat-chip-set>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="watchlistResultCode">
                            <th mat-header-cell 
                                *matHeaderCellDef 
                                class="table-chip-header" 
                                [matTooltip]="'Watchlist'"> 
                                {{ userContextProvider.isNaUser() ? 'W' : 'S' }}
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-chip-set class="mat-chip-list-stacked">
                                    <mat-chip [ngClass]="element.watchlistResultCode?.color" class="table-chip">
                                        {{element.watchlistResultCode?.text}}
                                    </mat-chip>
                                </mat-chip-set>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="sexOffenderResultCode" *ngIf="userContextProvider.isNaUser()">
                            <th mat-header-cell *matHeaderCellDef class="table-chip-header" [matTooltip]="'Sex Offender Registries'"> S </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-chip-set class="mat-chip-list-stacked">
                                    <mat-chip [ngClass]="element.sexOffenderResultCode?.color" class="table-chip">
                                        {{element.sexOffenderResultCode?.text}}
                                    </mat-chip>
                                </mat-chip-set>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="nationalCriminalCode" *ngIf="userContextProvider.isNaUser()">
                            <th mat-header-cell *matHeaderCellDef class="table-chip-header" [matTooltip]="'Criminal'"> C </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-chip-set class="mat-chip-list-stacked">
                                    <mat-chip [ngClass]="element.nationalCriminalCode?.color" class="table-chip">
                                        {{element.nationalCriminalCode?.text}}
                                    </mat-chip>
                                </mat-chip-set>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="badGuestResultCode" *ngIf="userContextProvider.isNaUser()">
                            <th mat-header-cell *matHeaderCellDef class="table-chip-header" [matTooltip]="'Safely’s Prior Rental Database'"> Safely DB </th>
                            <td mat-cell *matCellDef="let element">
                                <mat-chip-set class="mat-chip-list-stacked">
                                    <mat-chip [ngClass]="element.badGuestResultCode?.color" class="table-chip">
                                        {{element.badGuestResultCode?.text}}
                                    </mat-chip>
                                </mat-chip-set>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="lastEmailSent">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef> Last Email Sent </th>
                            <td mat-cell *matCellDef="let element"> {{element.lastEmailSent | date}} </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: tableColumns;" (click)="onRowClick(row)"></tr>
                    </table>
                    @if (loading | async) {
                        <div class="d-flex justify-content-center">
                            <mat-spinner></mat-spinner>
                        </div>
                    }
                    <div class="d-flex paginator-row align-items-baseline">
                        <div class="col-10">
                            <mat-paginator (page)="onPageEvent($event)" [pageSizeOptions]="[10, 20, 50, 100]" [length]="tableLength"
                                [pageSize]="10" aria-label="Select page" showFirstLastButtons>
                            </mat-paginator>
                        </div>
                        <div class="col-2 d-flex align-items-baseline">
                            <mat-form-field appearance="fill" class="go-to" id="goToPage">
                                <input type="number" matInput class="go-to-input" placeholder="Page" [(ngModel)]="pageNumber">
                            </mat-form-field>
                            <button mat-raised-button class="action-button" (click)="onGoToPageClick()" class="action-button">Go</button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
}